import * as types from "../constants";
import axios from "../../plugins/axios";
import { invalidate } from "../../hooks/queries/useCaseSummary";

const apiUrl = process.env.REACT_APP_CASENEST_API_URL;

export const caseSummaryActionCreators = {

    requestSummary: (caseId, summaryId) => async (dispatch, getState) => {

        dispatch({
            type: types.SET_CASE_SUMMARY_STATE,
            caseId,
            payload: {
                requested: true,
            }
        });

        await axios.get(`${apiUrl}/casesummary/${caseId}/request`);

        let intervalId = setInterval(async () => {

            const result = await axios.get(`${apiUrl}/casesummary/${caseId}/check/${summaryId}`);            

            if (result.data) {
                clearInterval(intervalId);

                invalidate(caseId);

                dispatch({
                    type: types.SET_CASE_SUMMARY_STATE,
                    caseId,
                    payload: {
                        requested: false,
                        alert: true,
                    }
                });
            }
        }, 15000);
    },   
   
    clearAlert: (caseId) => async (dispatch) => {
        dispatch({
            type: types.SET_CASE_SUMMARY_STATE,
            caseId,
            payload: {
                alert: false
            }
        });
    },
    
};

export default caseSummaryActionCreators;